import { render, staticRenderFns } from "./DashboardRDIWeeklyModal.vue?vue&type=template&id=6f92e3b8&scoped=true"
import script from "./DashboardRDIWeeklyModal.vue?vue&type=script&lang=js"
export * from "./DashboardRDIWeeklyModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardRDIWeeklyModal.vue?vue&type=style&index=0&id=6f92e3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f92e3b8",
  null
  
)

export default component.exports